module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.classes
  }, _vm._l((_vm.signatures), function(s) {
    return _c('div', {
      staticClass: "signature"
    }, [_c('div', {
      staticClass: "user-icon"
    }, [_c('img', {
      attrs: {
        "src": _vm.iconSource
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "user-name"
    }, [_c('div', {
      staticClass: "signature-name"
    }, [_vm._v(_vm._s(s.firstName) + " " + _vm._s(s.lastName))]), _vm._v(" "), _c('div', {
      staticClass: "signature-time"
    }, [_vm._v(_vm._s(_vm.action) + " " + _vm._s(s.timeDifference))])])])
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ce8939f8","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-webpack-plugin/loader.js?id=bhy68egj1x!./~/string-replace-webpack-plugin/loader.js?id=wgppdwdx8dq!./src/components/utils/LastSignatures.vue
// module id = 668
// module chunks = 0